module.exports = __webpack_public_path__ + "img/footer_logo.d1389b3d.svg";